/**
 * Preview Registry — single source of truth for /v2, /v3, /v4, /v5, /v6...
 *
 * Each preview lives self-contained at `src/previews/vN/`. To delete a preview:
 *   1. `rm -rf src/previews/vN/`
 *   2. Remove its line from PREVIEWS below.
 *
 * No other file in the app should reference a specific preview directly.
 */

import { lazy, type LazyExoticComponent } from 'react'

interface Preview {
  path: string
  element: LazyExoticComponent<React.ComponentType>
}

export const PREVIEWS: Record<string, Preview> = {
  v2: {
    path: '/v2',
    element: lazy(() => import('./v2/page')),
  },
  v3: {
    path: '/v3',
    element: lazy(() => import('./v3/page')),
  },
  v4: {
    path: '/v4',
    element: lazy(() => import('./v4/page')),
  },
  v5: {
    path: '/v5',
    element: lazy(() => import('./v5/page')),
  },
  v6: {
    path: '/v6',
    element: lazy(() => import('./v6/page')),
  },
}
